import Vue from 'vue'
import IOdometer from 'vue-odometer'

Vue.component('VueOdometer', IOdometer)
